import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingScreen() {
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '100vh'
    },
    "data-test-id": "loading-screen",
    "aria-busy": true,
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true
    })
  });
}
export default LoadingScreen;